/**
 * 设备故障信息补录
 */

// 公共方法
import { setStoreApiDate } from '../utils'
const prefix = '/dseWeb'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 查询列表（分页）
    async fetchSupplementPage({ commit, getters }, params) {
      const { supplementPage } = getters.getHttps
      const { data } = await supplementPage(params)
      return setStoreApiDate(data, commit)
    },
    // 新增或修改
    async fetchInsetOrUpdateSupplement({ commit, getters }, params) {
      const { insetOrUpdateSupplement } = getters.getHttps
      const { data } = await insetOrUpdateSupplement(params)
      return setStoreApiDate(data, commit)
    },
    // 查询单个详情
    async fetchGetSupplementInfoById({ commit, getters }, params) {
      const { getSupplementInfoById } = getters.getHttps
      const { data } = await getSupplementInfoById(params)
      return setStoreApiDate(data, commit)
    },
    // 删除单个详情
    async fetchDeleteSupplement({ commit, getters }, params) {
      const { deleteSupplement } = getters.getHttps
      const { data } = await deleteSupplement(params)
      return setStoreApiDate(data, commit)
    },
    // 根据设备id查询列表
    async fetchGetErrorListByDeviceId({ commit, getters }, params) {
      const { getErrorListByDeviceId } = getters.getHttps
      const { data } = await getErrorListByDeviceId(params)
      return setStoreApiDate(data, commit)
    },
  }
}
